import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Input, Icon } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { getService, saveService } from "../../api/Organization"

/* Helpers */
import { utils } from "../../helpers"

/* Widgets */
import { toast } from "../common"

Modal.setAppElement("#root")


/* Duration presets of the form, the rest is entered by hand */
const DURATIONS = [15, 30, 45, 60, 90, 120]

/* The empty form of a service */
const INITIAL = { id: 0, name: "", categoryID: 0, fixed: true, price: "", endPrice: "", discount: "", sessionTime: "", members: [] }


/* Widget Service Modal — a new service of the point and the changes of an existing one.
   It is opened by the reference: this._service.open(id) */
class ServiceModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            status: "ok",
            saving: false,
            ...INITIAL
        }
    }

    /* Open the form — without an identifier it creates a new service */
    open = (id = 0) => {

        this.setState({ visible: true, saving: false, status: id ? "loading" : "ok", ...INITIAL, id }, () => {

            /* An existing service is read together with the masters who provide it */
            if (!id) {
                return
            }

            getService({ id }).then(response => {

                if (response && response.status === 200) {

                    const { service, selected } = response.data

                    this.setState({
                        status: "ok",
                        name: utils.check(service.name, ""),
                        categoryID: service.categoryID ? parseInt(service.categoryID) : 0,
                        fixed: parseInt(service.isFixedPrice) !== 0,
                        price: service.price ? `${parseInt(service.price)}` : "",
                        endPrice: service.endPrice ? `${parseInt(service.endPrice)}` : "",
                        discount: service.discount ? `${parseInt(service.discount)}` : "",
                        sessionTime: service.sessionTime ? `${parseInt(service.sessionTime)}` : "",
                        members: selected
                    })
                }
                else {
                    this.setState({ status: "error" })
                }
            }).catch(() => this.setState({ status: "error" }))
        })
    }

    /* Close the form */
    close = () => {

        /* The request is already on its way */
        if (this.state.saving) {
            return
        }

        this.setState({ visible: false })
    }

    /* Add the master to the service or take him away */
    member = memberID => {

        const { members } = this.state
        const index = members.findIndex(item => parseInt(item) === parseInt(memberID))

        if (index > -1) {
            members.splice(index, 1)
        }
        else {
            members.push(parseInt(memberID))
        }

        this.setState({ members })
    }

    /* Save the service */
    save = () => {

        /* Fields */
        const { id, name, categoryID, fixed, price, endPrice, discount, sessionTime, members, saving } = this.state
        const { organizationID, onSaved } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        if (name.trim().length === 0) {
            this._name.error("Введите название услуги")
            return
        }

        if (!/^\d+$/.test(price)) {
            this._price.error("Введите стоимость услуги")
            return
        }

        if (!fixed && !/^\d+$/.test(endPrice)) {
            this._endPrice.error("Введите верхнюю цену")
            return
        }

        if (!fixed && parseInt(endPrice) <= parseInt(price)) {
            this._endPrice.error("Верхняя цена должна быть больше")
            return
        }

        if (discount.length > 0 && !/^\d+$/.test(discount)) {
            this._discount.error("Неверный формат скидки")
            return
        }

        if (discount.length > 0 && parseInt(discount) >= parseInt(price)) {
            this._discount.error(fixed ? "Скидка должна быть меньше цены" : "Скидка должна быть меньше нижней цены")
            return
        }

        if (!/^\d+$/.test(sessionTime) || parseInt(sessionTime) < 1) {
            this._sessionTime.error("Введите длительность услуги")
            return
        }

        this.setState({ saving: true })

        saveService({
            id: id ? id : null,
            organizationID,
            name: name.trim(),
            categoryID: categoryID ? categoryID : null,
            isFixedPrice: fixed ? 1 : 0,
            price,
            endPrice: fixed ? null : endPrice,
            discount: discount.length > 0 ? discount : null,
            sessionTime,
            members
        }).then(response => {

            this.setState({ saving: false })

            if (response && response.status === 200) {
                this.setState({ visible: false })
                onSaved()
                toast.success(id ? "Услуга сохранена" : "Услуга добавлена")
            }
            else {
                toast.error("Не удалось сохранить услугу")
            }
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Не удалось сохранить услугу")
        })
    }

    /* The body of the form */
    _body = () => {

        /* Fields */
        const { status, name, categoryID, fixed, price, endPrice, discount, sessionTime, members, saving } = this.state
        const { categories, team } = this.props

        if (status === "loading") {
            return (
                <div className="wide-modal-loading"><LoadingOutlined /></div>
            )
        }

        if (status !== "ok") {
            return (
                <div className="wide-modal-loading">
                    <Icon name="alert" size={38} width={1.5} />
                    <p>Не удалось загрузить услугу</p>
                </div>
            )
        }

        /* The masters who still work in the point */
        const active = team.filter(member => parseInt(member.active) === 1)

        return (
            <div className="wide-modal-body">

                <Input ref={ref => this._name = ref} label="Название услуги" value={name} onChange={event => this.setState({ name: event.target.value })} />

                <div className="wide-modal-label">Категория</div>
                <div className="organization-details-chips">
                    {categories.map(category =>
                        <div
                            key={`${category.id}`}
                            onClick={() => this.setState({ categoryID: parseInt(category.id) })}
                            className={`organization-details-chip select ${parseInt(categoryID) === parseInt(category.id) ? "active" : ""}`}
                        >
                            {category.name}
                        </div>
                    )}
                </div>

                <div className="wide-modal-label">Цена</div>
                <div className="organization-details-chips">
                    <div onClick={() => this.setState({ fixed: true })} className={`organization-details-chip select ${fixed ? "active" : ""}`}>Фиксированная</div>
                    <div onClick={() => this.setState({ fixed: false })} className={`organization-details-chip select ${fixed ? "" : "active"}`}>Диапазон «от — до»</div>
                </div>

                <div className="organization-details-inputs">

                    <Input ref={ref => this._price = ref} label={fixed ? "Стоимость, ₸" : "Цена от, ₸"} value={price} onChange={event => this.setState({ price: event.target.value })} />

                    {!fixed && <Input ref={ref => this._endPrice = ref} label="Цена до, ₸" value={endPrice} onChange={event => this.setState({ endPrice: event.target.value })} />}

                    <Input ref={ref => this._discount = ref} label="Цена по скидке, ₸" hint="Пусто — услуга без скидки" value={discount} onChange={event => this.setState({ discount: event.target.value })} />

                </div>

                <div className="wide-modal-label">Длительность</div>
                <div className="organization-details-chips">
                    {DURATIONS.map(duration =>
                        <div
                            key={`${duration}`}
                            onClick={() => this.setState({ sessionTime: `${duration}` })}
                            className={`organization-details-chip select ${parseInt(sessionTime) === duration ? "active" : ""}`}
                        >
                            {duration} мин
                        </div>
                    )}
                </div>

                <Input ref={ref => this._sessionTime = ref} label="Длительность, минут" value={sessionTime} onChange={event => this.setState({ sessionTime: event.target.value })} />

                <div className="wide-modal-label">Кто оказывает услугу</div>
                <div className="wide-modal-hint">Если никого не выбрать, услугу получит вся команда.</div>

                <div className="organization-details-chips">
                    {active.map(member =>
                        <div
                            key={`${member.memberID}`}
                            onClick={() => this.member(member.memberID)}
                            className={`organization-details-chip select ${members.findIndex(item => parseInt(item) === parseInt(member.memberID)) > -1 ? "active" : ""}`}
                        >
                            {utils.check(member.name, "Без имени")}
                        </div>
                    )}
                </div>

                <div onClick={() => this.save()} className={`organization-details-button ${saving ? "disabled" : ""}`}>
                    {saving ? "Сохраняем..." : "Сохранить"}
                </div>

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, id } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>{id ? "Редактировать услугу" : "Новая услуга"}</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {this._body()}

            </Modal>
        )
    }
}

export default ServiceModal
